module.exports = __webpack_public_path__ + "static/payment-page-preview_es-e001a62b9b5d892d1dfcf6f5f203d01a.png";